import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingTemplate } from '../../interfaces'

type Params = number | { id?: number } | undefined

const useTrainingGroupTemplatesForPersonQueryBase = buildGetQuery<
  Params,
  undefined,
  ITrainingTemplate[] | undefined
>({
  getRequest: (params) => {
    const id = typeof params === 'number' ? params : params?.id
    return {
      method: 'get',
      url: `${config.baseUrl}/People/${id ?? ''}/group-templates`,
      skip: !id,
    }
  },
  getQueryKey: (params) => {
    const id = typeof params === 'number' ? params : params?.id
    return ['training-group-templates-for-person', id]
  },
})

const useTrainingGroupTemplatesForPersonQuery = (
  params?: Params,
  options?: QueryObserverOptions<ITrainingTemplate[] | undefined, Error>,
) => useTrainingGroupTemplatesForPersonQueryBase(params, undefined, options)
export default useTrainingGroupTemplatesForPersonQuery